/**
 * Page-level permission contracts shared by routing and navigation.
 *
 * The regularization workspace supports self-service, scoped approval queues,
 * and correction history. Approval-only governance users must be able to open
 * the workspace even though request visibility remains restricted server-side
 * to work explicitly assigned to them.
 */
export const REGULARIZATION_PAGE_ACCESS_PERMISSIONS: string[] = [
  'attendance:regularization:read:self',
  'attendance:regularization:read:team',
  'attendance:regularization:read:department',
  'attendance:regularization:read:tenant',
  'attendance:regularization:approve:team',
  'attendance:regularization:approve:department',
  'attendance:regularization:approve:tenant',
  'attendance:corrections:read:self',
  'attendance:corrections:read:team',
  'attendance:corrections:read:department',
  'attendance:corrections:read:tenant',
];

/**
 * Overtime supports self-service data plus a request-scoped approval worklist.
 * An auth-only Governance Approver may enter through the approval permission,
 * while the service returns only requests explicitly routed to that user.
 */
export const OVERTIME_PAGE_ACCESS_PERMISSIONS: string[] = [
  'attendance:overtime:read:self',
  'attendance:overtime:read:team',
  'attendance:overtime:read:department',
  'attendance:overtime:read:tenant',
  'attendance:overtime:approve:team',
  'attendance:overtime:approve:department',
  'attendance:overtime:approve:tenant',
  'attendance:overtime-request:read:self',
  'attendance:overtime-request:read:team',
  'attendance:overtime-request:read:department',
  'attendance:overtime-request:read:tenant',
  'attendance:overtime-request:approve:team',
  'attendance:overtime-request:approve:department',
  'attendance:overtime-request:approve:tenant',
];
